<template>
  <div id="profileTab">
    <b-card-group columns>
      <b-card no-body>
        <b-card-header>
          Image
        </b-card-header>
        <b-table-simple>
          <b-tr>
            <b-td class="text-center">
              <img
                :src="'https://cdn.gokaizen.com/' + $store.state.global.manufacturer.thumbnail"
                alt=""
                style="max-width:200px;"
              >
            </b-td>
          </b-tr>
        </b-table-simple>
      </b-card>
      <b-card no-body>
        <div class="card-header">
          Settings
        </div>
        <b-table-simple>
          <b-tr>
            <b-td>Featured</b-td>
            <b-td class="text-right">
              {{ $store.state.global.manufacturer.featured ? 'Yes' : 'No' }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>Created</b-td>
            <b-td class="text-right">
              {{ $store.state.global.manufacturer.created | moment("YYYY-MM-DD") }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>Updated</b-td>
            <b-td class="text-right">
              {{ $store.state.global.manufacturer.updated | moment("YYYY-MM-DD") }}
            </b-td>
          </b-tr>
        </b-table-simple>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
export default {
  name: 'ManufacturerProfileTab',
};
</script>
